// extracted by mini-css-extract-plugin
export default {"modal":"Announcements_modal__3pDJl","footer":"Announcements_footer__SIH2-"};